/**
 * Created by mestrad on 2018. 06. 28..
 */

export default DataSheet;

import TimeLine from "./TimeLine";
import Map from "./Map";
import Gallery from "./Gallery";
import Common from "./Common";
import AjaxRequest from "./Ajax";
import SearchRequest from "./Search/Request";
import Style from "./Style";
import Suggestion from "./Suggestion";
import DataTable from './DataTable';
import ExportData from './ExportData';
import Logo from './Logo';
import SubOrdinate from './SubOrdinate';
import PageParameters from './PageParameters';

const $ = jQuery;
let entity;

function DataSheet(config) {
    var id;
    var data;
    var actualDate;
    var parentSystemType;
    var mapHandler;
    var logoHandler;
    var subOrdinateHandler;
    var timeLineHandler;
    var galleryHandler;
    var ajaxUrl;

    function init() {
        initBaseEvents();
        timeLineHandler = new TimeLine({
            locale: config.locale,
            type: "datasheet",
            selectors: {
                elementId: config.domElements.timeLineSelectors.timeLine,
                moveLeftId: config.domElements.timeLineSelectors.timeLineMoveLeft,
                moveRightId: config.domElements.timeLineSelectors.timeLineMoveRight,
                zoomInId: config.domElements.timeLineSelectors.timeLineZoomIn,
                zoomOutId: config.domElements.timeLineSelectors.timeLineZoomOut,
            },
            domElements: {
                wrapperSelector: config.domElements.timeLineWrapper,
                actualDatePicker: config.domElements.dataSheetActualDate
            }
        });
        mapHandler = new Map(
            {
                elementId: "geoMap",
                type: "datasheet",
                ajaxUrl: config.ajaxUrl
            }
        );

        logoHandler = new Logo(
            {
                type: "datasheet",
                ajaxUrl: config.ajaxUrl
            }
        );

        subOrdinateHandler = new SubOrdinate(
            {
                type: "datasheet",
                ajaxUrl: config.ajaxUrl
            }
        );

        galleryHandler = new Gallery();
        id = parseInt(Common.getUrlParam("id") || config.id);
        actualDate = Common.getUrlParam("date") || Common.getCurrentDate();
        parentSystemType = 0;
        if (id && actualDate) {
            $(config.domElements.eventHandlerNode).trigger("showDataSheet", {
                id: id,
                actualDate: actualDate,
                parentSystemTypeId: parentSystemType
            });

            PageParameters.setParam('id', id);
            PageParameters.setParam('date', actualDate);
        }
    }


    async function initBaseEvents() {
        $(config.domElements.eventHandlerNode).on("showDataSheet",
            async function (event, feed, arg2) {
                Style.show($(config.domElements.dataSheetWidgetClass));
                id = feed.id;
                actualDate = new Date(feed.actualDate);
                parentSystemType = feed.parentSystemType;
                ajaxUrl = config.ajaxUrl;
                $( '.NNP_otheroptions_widget > .nnpButtonContainer' ).toggle( false );
                const $tmplDataBlockOtherOptions = $( '#tmpl-data-block-other_options' );
                let displayButtonsContent = $tmplDataBlockOtherOptions.html().replace(
                    "class='save-entity nnpHidden",
                    "class='save-entity"
                );
                if ( $( 'body.logged-in' ).length !== 0 &&
                    [ 131962, 132899 ].includes(
                        parseInt( memorialClass, 10 ) ) ) {
                    displayButtonsContent = displayButtonsContent.replace(
                        "class='entity-update nnpHidden",
                        "class='entity-update"
                    );
                }
                $tmplDataBlockOtherOptions.html( displayButtonsContent );
                await feedSubscribers("show");
                showExternalDataBaseBlocks(() => {
                    initToggleDataBlockEvent(config.domElements.toggleElementSelector);
                });
                $( 'footer .nnpSendSuggestionButton, footer .suggestion_registration' ).parent().hide();
            });
        $(config.domElements.eventHandlerNode).on("refreshDataSheet",
            async function (event, feed, arg2) {
                id = feed.id;
                actualDate = new Date(feed.actualDate);
                parentSystemType = feed.parentSystemType;
                await feedSubscribers("refresh");
                initToggleDataBlockEvent(config.domElements.toggleElementSelector);
            });
        $(config.domElements.eventHandlerNode).on(
            "destroyDataSheet",
            function (event, feed, arg2) {
                destroy();
            }
        );
    }

    function initToggleDataBlockEvent(selector) {
        $(selector).off("click");
        $(selector).on("click", function (event) {
            var wrapperId = $(event.currentTarget).closest('.nnpDataTableWrapper').attr("id");
            if (wrapperId === undefined) {
                wrapperId = $(event.currentTarget).closest('.nnpDataWrapper').attr('id');
            }
            if (wrapperId !== undefined) {
                toggleElement($(event.currentTarget));
            }
        });
    }

    function destroy() {
        var subscribers = $(".dataBlock[nnp-data-block='1']");

        subscribers.each(function (index, item) {
            $(item).html("");
        });
        galleryHandler.destroy();
        mapHandler.destroy();
        timeLineHandler.destroy();
    }

    function showExternalDataBaseBlocks(callback) {
        if ($(config.domElements.creationListWidget).html() !== undefined) {
            getExternalDataBaseResult('creation-list', null, config.fieldNames.creationList, (data) => {
                if (data !== undefined && data !== null && data.result !== undefined) {
                    var template = Handlebars.compile($(config.templates.creationListBlock).html());
                    var html = template({
                        result: data.result,
                        linkUrl: data.linkUrl,
                        widgetSelector: config.templates.creationListBlock.replace("#", ""),
                        title: 'Művei',
                    });
                    $(config.domElements.creationListWidget).append(html);
                    toggleElementListEvent();
                }
            });
        }
        if ($(config.domElements.workAboutHimListWidget).html() !== undefined) {
            getExternalDataBaseResult('work-about-him-list', null, config.fieldNames.workAboutHimList, (data) => {
                if (data !== undefined && data !== null && data.result !== undefined) {
                    var template = Handlebars.compile($(config.templates.workAboutHimListBlock).html());
                    var html = template({
                        result: data.result,
                        linkUrl: data.linkUrl,
                        widgetSelector: config.templates.workAboutHimListBlock.replace("#", ""),
                        title: "Róla szóló művek",
                    });
                    $(config.domElements.workAboutHimListWidget).append(html);
                    toggleElementListEvent();
                }
            });
        }
        showExternalDataTables(() => {
            callback();
        });
    }

    function showExternalDataTables(callback) {
        var dataTableItems = $(config.domElements.externalDataTableWidget);
        if (dataTableItems.length !== 0) {
            var template = Handlebars.compile($(config.templates.externalDataTableBlock).html());
            dataTableItems.each((index, item) => {
                var classList = item.className.split(' ');
                var regex = new RegExp("^" + config.domElements.externalDataTableWidgetClass + "\\d+", 'i');
                var itemClass = null;
                classList.forEach((item) => {
                    if (regex.exec(item) !== null) {
                        itemClass = item;
                    }
                });
                if (item !== undefined && itemClass !== null) {
                    // getExternalDataBaseResult('other-data', itemClass, config.fieldNames.dataTable, (data) => {
                    getExternalDataBaseResult('data-table', itemClass, config.fieldNames.dataTable, (data) => {
                        if (data.result !== null) {
                            var html = template({
                                result: data.result,
                                fieldNameList: data.fieldNameList,
                                title: data.title,
                                widgetSelector: config.templates.externalDataTableBlock.replace("#", ''),
                                type: "external_datatable",
                            });
                            if (data.result !== undefined) {
                                $(item)
                                    .html(html)
                                    .removeClass('nnpHidden');
                            }
                            callback();
                        }
                    });
                }
            });
        } else {
            callback();
        }
    }

    function toggleHiddenClass(list, status) {
        list.each((index, item) => {
            if (index >= 4) {
                if (status === "open") {
                    item.classList.remove('nnpHidden');
                } else {
                    item.classList.add('nnpHidden');
                }
            }
        });
    }

    function toggleElement(selector) {
        if (selector.hasClass("closed")) {
            selector.removeClass('closed');
            selector.addClass('open');
        } else {
            selector.removeClass('open');
            selector.addClass('closed');
        }
    }

    function getExternalDataBaseResult(actionType, blockId, fieldNames, callback) {
        var request = {
            url: ajaxUrl + "/" + actionType,
            // url: config.externalDataBaseUrl,
            data: {
                action: actionType,
                object_type: config.objectType,
                id: id,
                block_id: blockId,
                //TODO ideiglenes
                fields: JSON.stringify(fieldNames),
            },
            success: function (response) {
                if (response.success) {
                    callback(response.data);
                }
            }
        };
        AjaxRequest(request);
    }

    function addDelay(timeoutMicroSeconds) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve('resolved');
            }, timeoutMicroSeconds);
        });
    }

    async function feedSubscribers(actionType) {
        var subscribers = $(".dataBlock[nnp-data-block='1']");
        remoteData({}, actionType, async function (result) {
            data = configData(result, actionType);

            if (actionType === "refresh") {

                logoHandler.refresh([data], config.objectType);
                subOrdinateHandler.refresh([data], config.objectType);
                var result = await addDelay(300);
            }


            subscribers.each(function (index, item) {
                renderTemplate($(this).data("view"), data, item);
            });

            let identityContainer = jQuery('.dataBlockWrapper.identity_logo').find('ul');
            let nameContainer = jQuery('.dataBlock.name').find('ul');
            let baseContainer = jQuery('.dataBlock.basedata').find('ul');
            if((identityContainer.length > 0) && (nameContainer.length > 0) && (baseContainer.length > 0)){
                let height = identityContainer.height();
                height = nameContainer.height() > height ? nameContainer.height() : height;
                height = baseContainer.height() > height ? baseContainer.height() : height;

                identityContainer.height(height);
                nameContainer.height(height);
                baseContainer.height(height);
            }

            galleryHandler.refresh();

            if (!memorialClass && !!data.current.type && config.objectType === 'memorial') {
                switch (data.current.type) {
                    case 'történelmi és nemzeti emlékhely':
                        memorialClass = '131961';
                        break;
                    case 'nemzeti sírkert':
                        memorialClass = '72257';
                        break;
                    case 'határon túli magyar emlékhely':
                        memorialClass = '131962';
                        break;
                    case 'évfordulós emlékhelyek':
                        memorialClass = '132899';
                        break;
                    default:
                        memorialClass = false;
                        break;
                }
            }

            if ( !! memorialClass ) {
                let menu = $(
                    'header .elementor-nav-menu--dropdown-none.elementor-hidden-mobile nav ul' );
                menu.find( 'li' ).removeClass( 'current_page_item' );
                let target;

                if ( config.objectType === 'memorial' ) {
                    switch ( memorialClass ) {
                        case '131961':
                            target = menu.find( 'li:nth-child(1)' );
                            break;
                        case '72257':
                            target = menu.find( 'li:nth-child(2)' );
                            break;
                        case '131962':
                            target = menu.find( 'li:nth-child(3)' );
                            break;
                        case '132899':
                            target = menu.find( 'li:nth-child(4)' );
                            break;
                        default:
                            target = null;
                            break;
                    }
                } else {
                    const objectTypeParam = location.pathname.split( '/' )[ 3 ];

                    if ( !! objectTypeParam ) {
                        target = menu.find( `.${ objectTypeParam }` );
                    }
                }

                if ( !! target ) {
                    target.addClass( 'current_page_item' );
                    [ ...target.parents( '.menu-item' ) ].forEach( e => {
                        e.classList.add( 'current_page_item' );
                    } );
                }

                if ( ! [ 131962, 132899 ].includes( parseInt( memorialClass ) ) ) {
                    $( '.NNP_datasheet_significance_block_widget' ).hide();
                }
            }

            if (data.map !== null && typeof(data.map) !== 'undefined' && data.map.length !== 0) {
                mapHandler.refresh([data]);

                let depthCount = 1;
                const getDepth = (array) => {
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index];
                        if (Array.isArray(element)) {
                            depthCount += 1;
                            getDepth(element);
                        }
                    }
                    return depthCount;
                };
                // const coordType = getDepth(data.map.coordinates);

                let arrFirst = [];
                const coordType = data.map.type;
                const coordVal = () => {
                    if ( coordType !== 'LineString' && coordType !== 'Point' &&
                        typeof data.map.coordinates !== 'undefined' ) {
                        let arr = data.map.coordinates[0][0];

                        const lenghtRate = arr.flat().length/2;
                        for (let i = 0; i < lenghtRate; i++) {
                            let x = arr[i].shift();

                            if (arrFirst.length < lenghtRate) {
                                arrFirst.push(x);
                            } else {
                                break;
                            }
                        }

                        let sumFirst = 0;

                        for (let index = 0; index < arrFirst.length; index++) {
                            sumFirst += arrFirst[index];
                        }

                        let sumLast = 0
                        arr = arr.flat();
                        for (let f = 0; f < arr.length; f++) {
                            sumLast += arr[f];
                        }

                        let X = sumFirst/arrFirst.length;
                        let Y = sumLast/arr.length;
                        return [X,Y];

                    } else if (coordType === "Point") {

                        return data.map.coordinates;

                    } else if (coordType === "LineString") {

                        let arr = data.map.coordinates;

                        const lenghtRate = arr.flat().length/2;
                        for (let i = 0; i < lenghtRate; i++) {
                            let x = arr[i].shift();

                            if (arrFirst.length < lenghtRate) {
                                arrFirst.push(x);
                            } else {
                                break;
                            }
                        }

                        let sumFirst = 0;

                        for (let index = 0; index < arrFirst.length; index++) {
                            sumFirst += arrFirst[index];
                        }

                        let sumLast = 0
                        arr = arr.flat();
                        for (let f = 0; f < arr.length; f++) {
                            sumLast += arr[f];
                        }

                        let X = sumFirst/arrFirst.length;
                        let Y = sumLast/arr.length;
                        return [X,Y];

                    }
                }
                var daddr = coordVal() ? coordVal().slice().reverse() : '';
                if ( jQuery( '#routePlannerWrap' ).length === 0 ) {
                $("#geoMap").parent().prepend(`
                <form method="get" action="https://www.google.com/maps" target="mappframe" id="routePlannerWrap" style="">
                    <input name="saddr" type="hidden" id="saddr" placeholder="Útvonaltervezés">
                    <input name="output" type="hidden" value="dir">
                    <input name="dirflg" type="hidden" value="d">
                    <input name="f" type="hidden" value="d">
                    <input name="z" type="hidden" value="11">
                    <input name="daddr" type="hidden" id="daddr" 
                    value=${daddr}>
                    <input type="submit" name="Submit" id="routeIcon" value="Útvonaltervezés">
                </form>
                `);
                } else if (typeof coordVal() !== 'undefined') {
                    jQuery( '#routePlannerWrap input[name="daddr"]' )
                        .val( daddr );
                }

            } else {
                $('#geoMap').addClass('nnpHidden');
            }

            timeLineHandler.refresh(prepareTimeLineData(data), actualDate);


            if (actionType === "show") {
                if ($(config.domElements.settlementStatisticDataTableWidget).length > 0) {
                    DataTable({
                        type: "settlement_statistic",
                        dataSheetConfig: config,
                        objectId: data.id,
                        title: "Településstatisztika",
                        selector: config.domElements.settlementStatisticDataTableWidget,
                        columnLimit: 6,
                        objectType: config.objectType,
                    });
                }
                if ($(config.domElements.electionDataTableWidget).length > 0) {
                    DataTable({
                        type: "election",
                        dataSheetConfig: config,
                        objectId: data.id,
                        title: "Választási adatok",
                        selector: config.domElements.electionDataTableWidget,
                        columnLimit: 4,
                        objectType: config.objectType,
                    });
                }
            }
            initElementsAndEvents();
            initDataSheetSearchBtnEvent();
            initToggleDataBlockEvent(config.domElements.toggleElementSelector);
            wrapperListToggle(false);
            entity = data;
        });
    }


    function wrapperListToggle(hide = true) {
        let wrapperList = $('.bodywrapper .ult-wrapper');
        wrapperList.each((index, item) => {
            if (!$(item).hasClass('searchBlokk')) {
                if (hide) {
                    $(item).addClass('nnpHidden');
                } else {
                    $(item).removeClass('nnpHidden');
                }
            }
        });
    }

    function changePageTitle(feed) {
        document.title = feed.current.title + " - " + document.title;
    }

    function configData(data, actionType) {
        data.actualDate = moment(actualDate).format("YYYY-MM-DD");
        data.locale = config.locale;
        if (config.objectType === "geo" || config.objectType === "memorial") {
            if (actionType === "show") {
                if (Array.isArray(data.relatedDataList)) {
                    data.relatedDataList.forEach(function (item) {
                        if (item.relatedType === "parentList" && item.items !== undefined) {
                            item.items.reverse();
                        }
                    });
                }
            }
        }

        // add direct link to identityList
        let addLink = true;
        data.identityList.forEach((item) => {
            if (item.title === 'link') {
                addLink = false;
            }
        });
        if (addLink) {
            const link = `${config.pages.basePage}/${config.objectType}/${data.id}`;
            const linkIdentity = {
                title: 'link',
                value: link
            };
            data.identityList.splice(1, 0, linkIdentity);
        }

        var jobList = [];
        var geoTypeList = [];
        var memorialTypeList = [];
        var corporateTypeList = [];
        var baseDataList = [];
        if (data.typeList) {
            data.typeList.forEach((item) => {
                if (item.type === "profession") {
                    jobList.push(item);
                }
                if (item.type === "geo_type") {
                    geoTypeList.push(item);
                }
                if (item.type === "memorial_type" ||
                    item.type === "memorial_nature_type" ||
                    item.type === "memorial_protecting_type" ||
                    item.type === "memorial_status_type" ||
                    item.type === "memorial_importance_type") {
                    memorialTypeList.push(item);
                }
                if (item.type === "corporate_type") {
                    corporateTypeList.push(item);
                }
                if (item.type === "gender" || item.type === "nationality") {
                    baseDataList.push(item);
                }
            });
        }

        baseDataList.forEach(item => {
            item.value = item.title;
            item.title = item.typeTitle;
        });
        if (data.dataList) baseDataList = $.merge(data.dataList, baseDataList);

        if (jobList.length > 0) data.jobList = jobList;
        if (geoTypeList.length > 0) data.geoTypeList = geoTypeList;
        if (memorialTypeList.length > 0) data.memorialTypeList = memorialTypeList;
        if (corporateTypeList.length > 0) data.corporateTypeList = corporateTypeList;
        if (baseDataList.length > 0) data.baseDataList = baseDataList;
        data.pages = config.pages;
        data.objectType = config.objectType;
        return data;
    }

    function renderTemplate(view, data, item) {
        $(item).html("");
        var originTemplate = $(config.templates.block[view]).html();
        var template;
        Object.assign(data, {widgetSelector: config.templates.block[view].replace("#", "")});
        if (!config.templates.block[view] || !originTemplate) {
            //console.error("Hiányzó nézet: " + view, config.templates.block);
            return;
        }
        if (view === "relateddatas") {
            if (Array.isArray(data.relatedDataList)) {
                data.relatedDataList.forEach(function (relatedListItem) {
                    if (relatedListItem.relatedType === "parentList") {
                        relatedListItem.actualDate = data.actualDate;
                        template = Handlebars.compile(originTemplate);
                        $(item).append(template(relatedListItem));

                    }
                });
                data.relatedDataList.forEach(function (relatedListItem) {
                    if (relatedListItem.relatedType === "patOfSettlement") {
                        relatedListItem.actualDate = data.actualDate;
                        template = Handlebars.compile(originTemplate);
                        $(item).append(template(relatedListItem));

                    }
                });
                data.relatedDataList.forEach(function (relatedListItem) {
                    if (relatedListItem.relatedType !== "patOfSettlement" && relatedListItem.relatedType !== "parentList") {
                        relatedListItem.actualDate = data.actualDate;
                        template = Handlebars.compile(originTemplate);
                        $(item).append(template(relatedListItem));
                    }
                });
            }
        } else if (view === "geonamecard") {
            var templateData;
            if (Array.isArray(data.relatedDataList)) {
                data.relatedDataList.forEach(function (relatedListItem) {
                    if (relatedListItem.relatedType == "parentList") {
                        templateData = {
                            current: data.current,
                            parentList: relatedListItem.items,
                            actualDate: data.actualDate,
                            logoUrl: data.logoUrl
                        };
                    }
                });
            } else {
                templateData = {
                    current: data.current,
                    actualDate: data.actualDate
                };
            }
            template = Handlebars.compile(originTemplate);
            $(item).html(template(templateData));
        } else if (view == "biography") {
            if (data.biographyList.length > 0) {
                data.biographyList[0].firstItem = true;
                template = Handlebars.compile(originTemplate);
                $(item).html(template(data));
            }
        } else {
            template = Handlebars.compile(originTemplate);
            $(item).html(template(data));
        }
    }

    function initElementsAndEvents() {
        $(config.domElements.dataSheetActualDate).datepicker({
            // changeMonth: true,
            changeYear: true,
            locale: config.locale,
            dateFormat: "yy. mm. dd.",
            yearRange: 'c-100:c',
            onChangeMonthYear: function () {
                var year = $( '#ui-datepicker-div .ui-datepicker-year :selected' ).val();
                var date = $.datepicker.formatDate( 'yy. mm. dd.', new Date( year, 0, 1 ) );
                $( this ).val( date );
                timeLineHandler.setCustomTimeDataSheet( date );
                $( config.domElements.eventHandlerNode ).trigger( 'refreshDataSheet', {
                    id: id, actualDate: date, parentSystemType: parentSystemType
                } );
            }
        } ).focus( function () {
            $( '#ui-datepicker-div' ).position( {
                my: 'left top', at: 'left bottom', of: $( this )
            } );
        } ).attr( 'readonly', false );
        /*
        $(config.domElements.dataSheetActualDate).on("change", function (event) {
            event.preventDefault();
            var $actualDate = $(config.domElements.dataSheetActualDate);
            let date = new Date($actualDate.val().substring(0, $actualDate.val().length - 1).replace(new RegExp('. ', 'g'), '-'));
            timeLineHandler.setCustomTimeDataSheet(date);
            $(config.domElements.eventHandlerNode).trigger("refreshDataSheet", {
                id: id,
                actualDate: date,
                parentSystemType: parentSystemType
            });
        });
        */
        // $(config.domElements.dataWrapper).on("click", function (event) {
        //     var wrapperId = "#" + event.currentTarget.id;
        //     if (wrapperId != "#") {
        //         if (config.objectType == "geo") $(wrapperId + " .dataList").slideToggle();
        //     }
        // });
        $(config.domElements.biographyDatas).on("click", function (event) {
            if ( event.target.tagName === 'A' ) {
                return;
            }
            var wrapperId = "#" + event.currentTarget.id;
            if (wrapperId != "#") {
                $(wrapperId + " .dataValue").slideToggle();
            }
        });

        if (!memorialClass) {
            $(config.domElements.sendSuggestionButton).on("click", function () {
                new Suggestion({
                    locale: config.locale,
                    objectType: config.objectType,
                    objectId: id,
                    domElements: config.domElements.suggestion,
                    ajaxUrl: config.ajaxUrl,
                });
            });
        }

        $('a[href^="mailto"]').each(function () {
            $(this).attr('href', $(this).attr('href').replace(/(http|https)?:?\/{2}/gm, ':'));
            $(this).siblings('.tooltip-text').html();
        });

        $('.dataBlock.link a').each(function () {
            const url = $(this).attr('href');
            $(this).siblings('.tooltip-text').html(url);
        });

        $(config.domElements.parentSystemType).on("change", function (event) {
            $(config.domElements.eventHandlerNode).trigger("refreshDataSheet", {
                id: id,
                actualDate: data.actualDate,
                parentSystemType: event.target.value
            });
        });
        $(config.domElements.exportDataBtn).on('click', function () {
            new ExportData({
                objectType: config.objectType,
                id: id,
                type: 'XML',
                ajaxUrl: ajaxUrl,
                dialog: config.domElements.exportDialog,
            });
        });
        $('body').on('click', '#save_entity', () => saveEntity(config.objectType, $('#form-field-list').val(), id));
        $( '.fa-copy' ).on( 'click', copy_to_clipboard );
        toggleElementListEvent();
    }

    function toggleElementListEvent() {
        $(config.domElements.toggleElementListSelector).off("click");
        $(config.domElements.toggleElementListSelector).on("click", function (event) {
            var $wrapper = $(event.currentTarget).parent();
            if ($wrapper !== undefined) {
                var status = "open";
                toggleElement($(event.currentTarget));
                if ($(event.currentTarget).hasClass("closed")) {
                    status = "closed";
                }
                toggleHiddenClass($wrapper.find('.dataList').children(), status);
            }
        });
    }

    function collectCurrentData(actualDate) {
        getCurrentElement(data.nameList, actualDate, 'title');
        if (config.objectType === "geo" || config.objectType === "memorial") {
            getCurrentElement(data.typeList, actualDate, 'type');
        }
    }

    function getCurrentElement(feed, actualDate, currentElementName) {
        let date = new Date(actualDate.substring(0, actualDate.length - 1).replace(new RegExp('. ', 'g'), '-'));
        var value = data.current[currentElementName];
        feed.forEach((item) => {
            var from = item.from === undefined || item.from === "" ? false : moment(item.from);
            var to = item.to === undefined || item.to === "" ? false : moment(item.to);
            if (from || to) {
                if (!from && to >= moment(date)) {
                    value = item.title;
                }
                if (!to && from <= moment(date)) {
                    value = item.title;
                }
                if (from <= moment(date) && to >= moment(date)) {
                    value = item.title;
                }
            }
        });
        data.current[currentElementName] = value;
    }

    function initDataSheetSearchBtnEvent() {
        $(config.domElements.dataSheetSearchBtn).on("click", function (event) {
            var $dataSheetSearch = $(config.domElements.dataSheetSearch);
            var searchConfig;
            if ($dataSheetSearch.hasClass("nnpHidden")) {
                Style.show($dataSheetSearch);
            } else {
                if ($dataSheetSearch.val() != "") {
                    searchConfig = {
                        objectType: config.objectType,
                        locale: config.locale,
                        page: 1,
                        limit: 50,
                        templates: {
                            resultList: "#tmpl-result-list",
                            resultListNoItem: "#tmpl-result-list-no-item"
                        },
                        domElements: {
                            dataSheetWidgetClass: "dataSheetBlockWidget",
                            eventHandlerNode: "#dataSheetManager",
                            resultList: ".nnpResultList",
                            resultListAllCheckbox: "#resultListCheckAllCheckbox",
                            resultListWidget: ".NNP_result_list_widget",
                            resultListWrapper: ".nnpResultListPlaceholder",
                            searchFilterBtnSelector: "#nnp_search_filter_btn",
                            searchForm: "#nnp_datasheet_search_form",
                            searchInput: "#dataSheetSearch",
                            searchMapSelector: "#searchMap",
                            searchSubmitBtn: "#nnp_search_submit",
                            searchWidget: ".NNP_search_widget",
                            wrapperSelector: "#customSearchWrapper",
                        }
                    };
                    SearchRequest(searchConfig);
                    wrapperListToggle();
                    document.title = config.searchPageTitle;
                    window.history.pushState({}, "", window.location.pathname);
                }
                $dataSheetSearch.addClass("nnpHidden");
            }
        });
        $(config.domElements.dataSheetSearch).keydown(function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                $(config.domElements.dataSheetSearchBtn).trigger("click");
                return false;
            }
        });
    }

    function prepareTimeLineData(data) {
        var timeData = [];
        var index = 0;
        var dataTitle = [];

        if (config.objectType === "geo" || config.objectType === "memorial") collectTimeDatas(data.nameList, "name");
        if (config.objectType === "person") collectTimeDatasFromDataList(data.dataList);
        if (config.objectType === "memorial") collectTimeDatasFromDataList(data.relatedDate);
        if (config.objectType !== "person") collectTimeDatas(data.typeList, "type");

        return timeData;

        function collectTimeDatasFromDataList(feed, type) {

            if (feed !== undefined) {
                feed.forEach(function (item) {
                    if (item.type === "birth_date") {
                        timeData.push({
                            from: item.value,
                            content: "<span>" + item.title + "</span>",
                            id: index,
                            className: "timeLineItemFrom timeLineItemType_name",
                            type: type
                        });
                        index++;
                    }
                    if (item.type === "death_date") {
                        timeData.push({
                            from: item.value,
                            content: "<span>" + item.title + "</span>",
                            id: index,
                            className: "timeLineItemTo timeLineItemType_name",
                            type: type
                        });
                        index++;
                    }
                    if (item.relatedType) {
                        timeData.push({
                            from: item.value,
                            content: "<span>" + item.title + "</span>",
                            id: index,
                            className: "timeLineItemTo timeLineItemType_name",
                            type: item.relatedType
                        });
                        index++;
                    }
                });
            }
        }

        function collectTimeDatas(feed, type) {
            if (feed !== undefined) {
                var firstItem = false;
                feed.forEach(function (item) {
                    if ((item.from !== undefined || item.to !== undefined) && (item.from !== '' || item.to !== '')) {
                        if (firstItem) {
                            appendIfTheSameStartDate(item, type);
                        } else {
                            pushToTimeData(item, type);
                            dataTitle.push({
                                title: item.title,
                                from: item.from
                            });
                            firstItem = true;
                        }
                    }
                });
                if (feed.length === 1 && feed[0].to !== undefined &&
                    feed[0].from !== undefined && feed[0].to !== '' &&
                    feed[0].from !== '') {
                    timeData.push({
                        from: feed[0].to,
                        content: "<span>" + feed[0].title + "</span>",
                        id: index,
                        className: "timeLineItemTo timeLineItemType_" + type,
                        type: type
                    });
                    index++;
                }
            }
        }

        function appendIfTheSameStartDate(feed, type) {
            timeData.forEach(function (timeDataItem, timeDataIndex) {
                if (type == timeDataItem.type && timeDataItem.from) {
                    if (timeDataItem.from.format("YYYY-MM-DD") == moment(feed.to).format("YYYY-MM-DD")) {
                        timeData[timeDataIndex].content = "<span>" + feed.title + "</span><span> | </span>" + timeData[timeDataIndex].content;
                        timeData[timeDataIndex].to = feed.from;
                        timeData[timeDataIndex].className = "timeLineItemFromTo timeLineItemType_" + type;
                    }
                    if (!existsItem(feed)) {
                        pushToTimeData(feed, type);
                        dataTitle.push({
                            title: feed.title,
                            from: feed.from
                        });
                    }
                }
            });
        }

        function existsItem(feed) {
            var exists = false;
            dataTitle.forEach(function (item) {
                if (item.title == feed.title && item.from == feed.from) exists = true;
            });
            return exists;
        }

        function pushToTimeData(item, type) {
            var className = "";
            if (moment(item.from).isValid()) {
                className = "timeLineItemFrom timeLineItemType_" + type;
            } else {
                className = "timeLineItemTo timeLineItemType_" + type;
            }
            timeData.push({
                from: item.from ? moment(item.from) : null,
                to: item.to ? moment(item.to) : null,
                content: "<span>" + item.title + "</span>",
                id: index,
                className: className,
                type: type
            });
            index++;
        }
    }

    function remoteData(feed, action, callback) {
        if (action === "refresh") {
            var $actualDate = $(config.domElements.dataSheetActualDate);
            collectCurrentData($actualDate.val());
            callback(data);
        } else {
            if (!window._sharedData.datasheet || window._sharedData.datasheet.length == 0 || window._sharedData.datasheet.id !== id) {
                var request = {
                    url: ajaxUrl + "/" + config.ajaxAction,
                    data: {
                        action: config.ajaxAction,
                        object_type: config.objectType,
                        id: id,
                        view_date: moment(actualDate).format("YYYY-MM-DD"),
                        locale: config.locale
                    },
                    success: function (response) {
                        if (response.success) {
                            let logourl = response.data.logoUrl;
                            response.data.logoUrl = logourl.replace('http', 'https');
                            changePageTitle(response.data);
                            callback(response.data);
                        }
                    }
                };
                if (config.objectType == "geo" || config.objectType === "memorial") $.extend(request.data, {parent_system_type: parentSystemType});
                AjaxRequest(request);
            } else {
                callback(window._sharedData.datasheet);
            }
        }
    }


    const saveEntity = (type, list, postID) => {
        $.ajax({
            type: 'POST',
            dataType: 'JSON',
            url: myAjax.ajaxUrl,
            data: {
                action: 'save_favorite_entity',
                postID: postID,
                type: type,
                list: list
            },
            success: function(response) {
                console.log(response);
            }
        });
    };

    const copy_to_clipboard = ( { target } ) => {
        const copyText = jQuery( target ).siblings( 'a' );

        navigator.clipboard.writeText( copyText.attr( 'href' ) );
    };

    init();
}

const formatLocationDetails = ( [ location = {} ] = [] ) => {
    const sortOrder = [
        'country', 'county', 'zip', 'settlement', 'address'
    ];
    const locationSorted = Object.keys( location )
        .sort( ( a, b ) => sortOrder.indexOf( a ) - sortOrder.indexOf( b ) )
        .reduce( ( obj, key ) => {
            obj[ key ] = location[ key ];
            return obj;
        }, {} );
    return Object.entries( locationSorted )
        .map( entry => entry[ 1 ][ 0 ].value )
        .join( ', ' );
};

const sortByTitle = ( { title: titleX }, { title: titleY } ) => titleX
    .localeCompare( titleY );

const getFirstType = ( data, type ) => {
    if ( ! data.hasOwnProperty( 'typeList' ) ) {
        return false;
    }

    const filteredType = Array.from( data.typeList )
        .filter( ( e ) => e.type === type );

    if ( ! filteredType.length ||
        ! filteredType[ 0 ].hasOwnProperty( 'title' ) ) {
        return false;
    }

    if ( filteredType.length === 1 ) {
        return filteredType[ 0 ].title;
    }

    filteredType.sort( sortByTitle );

    return filteredType[ 0 ].title;
};

const setFormEntityData = ( data,
    update = false ) => elementorFrontend.hooks.addAction(
    'frontend/element_ready/form.default', $scope => {
        const requiredClass = 'elementor-field-required elementor-mark-required';
        const fEntity = $scope.find( '#form-field-entity_data' );
        const fTitle = $scope.find( '#form-field-title' );
        const fLocationDetails = $scope.find( '#form-field-location_details' );
        const fCoordinates = $scope.find( '#form-field-coordinates' );
        const fContent = $scope.find('#form-field-content');
        const fContentSrc = $scope.find( '#form-field-content_source' );
        const fImportanceType = $scope.find(
            '#form-field-memorial_importance_type' );
        const fNatureType = $scope.find( '#form-field-memorial_nature_type' );
        const fStatusType = $scope.find( '#form-field-memorial_status_type' );
        const fImageSrc = $scope.find( '#form-field-image_source' );
        const fImage = jQuery( '#form-field-image' );
        const imageChange = ( { target } ) => fImageSrc.prop(
            { 'required': !! target.value } );

        fImage.off( 'change', imageChange );

        if ( [ 131962, 132899 ].includes( parseInt( memorialClass ) ) &&
            update ) {
            fEntity.val( JSON.stringify( data ) );
            fTitle.val( data.current.title )
                .prop( 'disabled', true ).parent().removeClass( requiredClass );
            fLocationDetails
                .val( `${ formatLocationDetails( data.locationDetails ) }` )
                .prop( { 'disabled': true, 'required': false } )
                .parent()
                .removeClass( requiredClass );
            fCoordinates.val( `${ document.getElementById( 'daddr' )
                .value.split( ',' ).slice().reverse().join( ' ' ) }` )
                .prop( 'disabled', true ).parent().removeClass( requiredClass );
            const natureType = getFirstType( data, 'memorial_nature_type' );
            if ( !! natureType ) {
                fNatureType.find( `option[value="${ natureType }"]` )
                    .attr( 'selected', 'selected' );
            }
            fNatureType.prop( { 'disabled': true, 'required': false } )
                .parent().parent().removeClass( requiredClass );
            const importanceType = getFirstType( data,
                'memorial_importance_type' );
            if ( !! importanceType ) {
                fImportanceType.find( `option[value="${ importanceType }"]` )
                    .attr( 'selected', 'selected' );
            }
            fImportanceType.prop( { 'disabled': true, 'required': false } )
                .parent().parent().removeClass( requiredClass );
            fStatusType.prop( { 'disabled': true, 'required': false } )
                .parent().parent().removeClass( requiredClass );
            fImageSrc.prop( 'required', false )
                .parent()
                .removeClass( requiredClass );
            fImage.prop( 'required', false )
                .parent()
                .removeClass( requiredClass );
            fContent.prop( 'required', false )
                .parent()
                .removeClass( requiredClass );
            fContentSrc.prop( 'required', false )
                .parent()
                .removeClass( requiredClass );
        } else {
            fEntity.val( '' );
            fTitle.val( '' ).prop( { 'disabled': false, 'required': true } )
                .parent().addClass( requiredClass );
            fCoordinates.val( '' )
                .prop( { 'disabled': false, 'required': true } )
                .parent().addClass( requiredClass );
            fLocationDetails.val( '' )
                .prop( { 'disabled': false, 'required': true } )
                .parent().addClass( requiredClass );
            fNatureType.prop( 'disabled', false );
            if ( fNatureType.is( ':visible' ) ) {
                fNatureType.prop( 'required', true )
                    .parent()
                    .parent()
                    .addClass( requiredClass );
            }
            fImportanceType.prop( 'disabled', false );
            if ( fImportanceType.is( ':visible' ) ) {
                fImportanceType.prop( 'required', true )
                    .parent()
                    .parent()
                    .addClass( requiredClass );
            }
            if ( fStatusType.is( ':visible' ) ) {
                fStatusType.prop( { 'disabled': false, 'required': true } )
                    .parent().parent().addClass( requiredClass );
            }
            fImageSrc.prop( 'required', true ).parent()
                .addClass( requiredClass );
            fContent.prop( 'required', true )
                .parent()
                .addClass( requiredClass );
            fContentSrc.prop( 'required', true )
                .parent()
                .addClass( requiredClass );
            fImage.prop( 'required', true ).parent().addClass( requiredClass );
            fImage.on( 'change', imageChange );
        }
    } );

$( document ).on( 'change', '#form-field-memorial_classification_type', ( { target } ) => {
    const selected_index = jQuery( target ).prop( 'selectedIndex' );

    const dynamic_field_groups = [
        'related_person',
        'memorial_protecting_type',
        'related_date',
        'cemetery_name',
        'memorial_nature_type',
        'memorial_type',
        'memorial_importance_type',
        'memorial_status_type',
        'related_corporate',
        'memorial_protecting_type_switch'
    ];
    const related_date_label = selected_index === 1
                               ? 'Védettség éve'
                               : 'Emlékhellyé nyilvánítás éve';
    const prefix = '.elementor-field-group-';
    /* Indexes of dynamic_field_groups */
    const set = [
        /* nemzeti sírkert */
        [ 0, 1, 3, 8 ],
        /* határontúli */
        [ 0, 4, 6, 7, 8, 9 ],
        /* évfordulós */
        [ 0, 4, 6, 7, 8, 9 ],
        /* nemzeti történelmi */
        [ 0, 4, 8 ]
    ];

    dynamic_field_groups.forEach( ( v, i ) => {
        if ( ! selected_index ) {
            jQuery( prefix + v ).hide();
            return false;
        }
        if ( i === 3 && selected_index <= 3 ) {
            jQuery( `${ prefix + v } label` ).text( related_date_label );
        }
        jQuery( prefix + v ).toggle( set[ selected_index - 1 ].includes( i ) );
    } );
} );

const setCities = popup => {
    const defaultCountry = 'HU';
    const countrySelect = popup.getElementById( 'form-field-country' );
    const citySelect = popup.getElementById( 'form-field-city' );
    const countries = countrySelect.options;
    let selectedIndex = countries.selectedIndex;
    if ( selectedIndex === 0 ) {
        countries.selectedIndex = Array.from( countries )
            .findIndex( ( { value } ) => value === defaultCountry );
    }
    $( countrySelect ).on( 'change', ( { target: { selectedIndex } } ) => {
        citySelect.setAttribute( 'disabled', true );
        const selectedCountry = selectedIndex !== 0
                                ? countries[ selectedIndex ].value
                                : defaultCountry;
        $.ajax( {
            type: 'POST',
            dataType: 'JSON',
            url: myAjax.ajaxUrl,
            data: {
                action: 'get_cities',
                country: selectedCountry
            }, success: ( { data: cities, success } ) => {
                if ( ! success ) {
                    return;
                }
                citySelect.options.length = 1;
                Object.values( cities ).forEach( ( v, i ) => {
                    citySelect.options[ i + 1 ] = new Option( v, v );
                } );
                citySelect.removeAttribute( 'disabled' );
            }
        } );
    } );
};

$( document )
    .on( 'change', '#form-field-memorial_protecting_type_switch',
        ( { target } ) => $( '#form-field-memorial_protecting_type' )
            .prop( 'selectedIndex', $( target ).prop( 'selectedIndex' ) ) );

$( document ).on( 'elementor/popup/show', function ( { target }, id ) {
    const saveEntity = target.activeElement.classList.contains( 'save-entity' );
    if ( saveEntity ) {
        document.getElementById( 'fav-entity-title' )
            .querySelector( '.elementor-heading-title' ).innerHTML =
            `<b>${ entity.current.title }</b> hozzáadása saját kedvenc entitások listához.`;
        const list = $( '#form-field-list' );
        if ( ! list.prop( 'selectedIndex' ) ) {
            list.prop( 'selectedIndex', 1 ).change();
        }
        return;
    }

    const update = target.activeElement.classList.contains( 'entity-update' );
    if ( Object.keys( target ).includes( 'Javaslat beküldése' ) ) {
        setFormEntityData( entity, update );
    }

    if ( Object.keys( target ).includes( 'Regisztráció' )
        || Object.keys( target ).includes( 'Javaslat regisztráció' ) ) {
        setCities( target );
        return;
    }
    const options = [ '72257', '132899', '131962', '131961' ];
    const selected_index = options.includes( memorialClass )
                           ? options.indexOf( memorialClass ) + 1 : 3;
    const classificationType = $( '#form-field-memorial_classification_type' );

    classificationType.children().first().prop( 'disabled', true );
    classificationType.prop( 'selectedIndex', selected_index ).change();
    if ( ! selected_index ) {
        return true;
    }
    classificationType.children()
        .not( ':first-child' )
        .not( `:nth-child(${ selected_index + 1 })` )
        .prop( 'disabled', !! selected_index );
} );
